import { PluginFunction, PluginOptions } from './plugin';

const AppendLogLevel: PluginFunction = ({ method, methodName, message }: PluginOptions) => {
  if (typeof message == 'object') {
    message.level = methodName;
  }

  return method(message);
};

export { AppendLogLevel };
